import React, {useEffect} from "react";
import NewHero from "../components/hero/newHero";
import Popular from "../components/popular/popular";
import LatestDesigns from "../components/latestDesigns/latestDesigns";
import Newsletter from "../components/newsletter/newsletter";
import PopularCategories from "../components/popularCategories/popularCategories";

const Home = () => {

    useEffect(() => {
        window.scrollTo(0, 0); 
    }, []);

    return (
        <div>
            <NewHero />
            <PopularCategories/>
            <Popular />
            <LatestDesigns />
            <Newsletter />
        </div>
    )
}

export default Home